export function bookmarksToBase64(bookmarks) {
  return btoa(JSON.stringify(bookmarks));
}

export function bookmarksFromBase64(bookmarks) {
  return JSON.parse(atob(bookmarks));
}
